import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["text", "toggle"];
  static values = {
    fullText: String,
    limit: Number,
    expanded: { type: Boolean, default: false }
  };

  connect() {
    this.originalText = this.textTarget.innerText.trim();
    this.updateToggle();
  }

  updateToggle() {
    const full = this.fullTextValue.trim();
    const truncated = this.truncate(full, this.limitValue);

    if (full.length <= truncated.length) {
      // No need for read more
      this.toggleTarget.innerText = "";
      return;
    }

    if (this.expandedValue) {
      this.textTarget.innerText = full;
      this.toggleTarget.innerText = "Read less";
    } else {
      this.textTarget.innerText = truncated;
      this.toggleTarget.innerText = "Read more";
    }
  }

  toggle(event) {
    event.preventDefault();
    this.expandedValue = !this.expandedValue;
    this.updateToggle();
  }

  truncate(text, limit) {
    const words = text.split(/\s+/);
    if (words.length <= limit) return text;
    return words.slice(0, limit).join(" ") + "...";
  }
}